import {
  Building2,
  Hammer,
  Home,
  PackageOpen,
  SprayCan,
  Trash2,
  Trees,
  Truck,
  Wrench,
} from "lucide-react";

const ICONS = { Building2, Hammer, Home, PackageOpen, SprayCan, Trash2, Trees, Truck, Wrench };

export const serviceIcon = (name) => ICONS[name] || Wrench;
